<script setup lang="ts">
import { ChevronDown } from 'lucide-vue-next'
import { useModelSelector } from '~/composables/useModelSelector'
import type { ModelId } from '~/composables/useModelSelector'

const { t } = useI18n()
const { modelId, setModel, options } = useModelSelector()

const currentLabel = computed(() => options.value.find(o => o.id === modelId.value)?.label ?? 'Fast')

function onChange(e: Event) {
  setModel((e.target as HTMLSelectElement).value as ModelId)
}
</script>

<template>
  <div v-if="options.length > 1" class="model-selector">
    <select
      :value="modelId"
      class="model-select"
      :title="t('chat.responseMode')"
      @change="onChange"
    >
      <option v-for="opt in options" :key="opt.id" :value="opt.id">
        {{ opt.label }}
      </option>
    </select>
    <span class="model-label">{{ currentLabel }}</span>
    <ChevronDown class="model-chevron" />
  </div>
</template>

<style scoped>
@reference "~/assets/css/tailwind.css";
.model-selector {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
}

.model-select {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  -webkit-appearance: none;
  appearance: none;
}

.model-label {
  font-size: 0.75rem;
  @apply text-muted-foreground;
  user-select: none;
  pointer-events: none;
}

.model-chevron {
  width: 0.75rem;
  height: 0.75rem;
  @apply text-muted-foreground;
  pointer-events: none;
}

.model-selector:hover .model-label,
.model-selector:hover .model-chevron {
  @apply text-foreground;
}
</style>
